import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/Shared/services/toast.service';
import { Messagetype } from '../Shared/model/enum';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  contactForm!: FormGroup;
  submitted = false;
  apiUrl = 'https://ivapi.knackbe.in/api/ContactUs/AddContactUsAsync';
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      id: [0],
      name: ['', [Validators.required, Validators.minLength(3)]],
      contactNo: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      emailId: ['', [Validators.required, Validators.email]],
      thoughts: ['', [Validators.required, Validators.minLength(5)]],
      isActive: [true]
    });
  }

 onSubmit() { 
    this.submitted = true;
    if (this.contactForm.valid) {
      this.http.post(this.apiUrl, this.contactForm.value).subscribe({
        next: () => {
          this.toastService.showToast(
            Messagetype.sucess,
            'Info',
            'Your message has been sent successfully!'
          );
        this.submitted = false;
        this.contactForm.reset();
        this.contactForm.patchValue({ id: 0, isActive: true });
        },
        error: (err) => {
          console.error(err);
          this.toastService.showToast(
            Messagetype.fail,
            'Error',
            'Something went wrong. Please try again.'
          );
        }
      });
    } else {
      this.contactForm.markAllAsTouched();
    }
  }
  get f() {
    return this.contactForm.controls;
  }
}
